import React, { useCallback, useMemo } from 'react';

export function useSelectEnumField<E extends Record<string | number, unknown>>(
  enumItems: E,
  name: string,
  value: E[keyof E] | undefined,
  onChangeCallback: (
    e: React.ChangeEvent<HTMLInputElement>,
    obj: unknown
  ) => void
) {
  const options = useMemo(
    () =>
      Object.values(enumItems)
        .filter((item) => !Number.isNaN(Number(item)))
        .map((val) => ({
          value: val,
        })),
    [enumItems]
  );
  const onChange = useCallback(
    (e, obj) => {
      const destrVal = typeof obj === 'object' ? obj.value : obj;
      e.target.value = destrVal;
      e.target.name = name;
      onChangeCallback(e, destrVal);
    },
    [name, onChangeCallback]
  );
  const val = useMemo(
    () => options.find((o) => o.value === value),
    [options, value]
  );

  return { options, onChange, value: val };
}
